export default class BasketSettings {
    constructor(dto) {
        this.pageSize = '';
        this.color = '';
        this.widgetTitle = '';
        this.filter = [];
        this.showOnExternalApps = false;

        if (dto) {

            this.pageSize = dto.PageSize;
            this.widgetTitle = dto.WidgetTitle;
            this.color = dto.Color || '#607d8b';
            this.filter = dto.Filter ? dto.Filter.split(',').map(function (id) { return { id: id + '', text: '' }; }) : [];
            this.showOnExternalApps = ((typeof dto.ShowOnExternalApps === 'boolean') || (dto.ShowOnExternalApps instanceof Boolean))
                ? dto.ShowOnExternalApps
                : dto.ShowOnExternalApps === 'true';
        }
    }

    toDto() {

        return {
            PageSize: this.pageSize,
            WidgetTitle: this.widgetTitle,
            Color: this.color,
            Filter: this.filter.map(item => parseInt(item.id)).join(),
            ShowOnExternalApps: this.showOnExternalApps.toString()
        };
    }
}